import type { PropsWithChildren } from "react";

import { graphql, useFragment } from "react-relay";

import { PageWithBreadCrumbs } from "app/components/layout/PageWithBreadCrumbs";
import { useSettingsBreadcrumbs } from "app/hooks/routing/useSettingsBreadcrumbs";

import type { McpSettingsPage_query$key } from "./__generated__/McpSettingsPage_query.graphql";

interface Props extends PropsWithChildren {
  queryRef: McpSettingsPage_query$key;
}

export function McpSettingsPage({ queryRef, children }: Props) {
  const data = useFragment(
    graphql`
      fragment McpSettingsPage_query on Query {
        ...PageWithBreadCrumbs_query
      }
    `,
    queryRef,
  );

  const breadcrumbs = useSettingsBreadcrumbs();

  return (
    <PageWithBreadCrumbs
      breadcrumbs={breadcrumbs}
      defaultTitle="Settings"
      queryRef={data}
      title="Stacklet MCP"
    >
      {children}
    </PageWithBreadCrumbs>
  );
}
